/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

export class DjPsychoGameAssets {

    public static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    public static BITMAP_FONT_WIN_COUNT_UP_BW = "NumbersWinCountUp_B";
    public static BITMAP_FONT_SYM_MULTIPLIER = "M_Numbers";
    public static BITMAP_FONT_TOTAL_MULTIPLIER = "Knob_Numbers";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FS_BACKGROUND: string = "freespinBackground";
    public static SFS_BACKGROUND: string = "Super_freespinBackground";
    public static FS_LOGO: string = "Logo/Logo_Gees";
    public static SFS_LOGO: string = "Logo/Logo_Psycho";

    public static OUTRO_WIN_TEXT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: OpenSans.FAMILY,
        wordWrap: false,
        fontWeight: FontWeight.BOLD,
        fontSize: 50,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 3,
        dropShadowDistance: 7,
        fill: [
            0x99ffff,
            0x33ccff,
            0x0066ff
        ],
        lineJoin: "round",
        stroke: "#0033cc",
        strokeThickness: 4
    });

    public static shakeWiggle = CustomWiggle.create("shakeWiggle", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone
    });
    public static shakeWiggle2 = CustomWiggle.create("shakeWiggle2", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone
    });

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(DjPsychoGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(DjPsychoGameAssets.BITMAP_FONT_WIN_COUNT_UP_BW, "fonts/bitmapfonts/NumbersWinCountUp_B.fnt"),
                    new BitmapFontAsset(DjPsychoGameAssets.BITMAP_FONT_SYM_MULTIPLIER, "fonts/bitmapfonts/M_Numbers.fnt"),
                    new BitmapFontAsset(DjPsychoGameAssets.BITMAP_FONT_TOTAL_MULTIPLIER, "fonts/bitmapfonts/Knob_Numbers.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json"),
                    new TextureAsset("backgroundsJpeg5", "sheets/backgroundsJpeg/backgroundsJpeg5.json"),
                    new TextureAsset("backgroundsJpeg6", "sheets/backgroundsJpeg/backgroundsJpeg6.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),

                ],
                animations: {
                    "Xtc": "Particles/Xtc_SEQ/Xtc_",
                    "P_Alien": "Particles/P_Alien_SEQ/P_Alien_"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                ]
            },
            {
                name: "medToHighJpegSheets",
                assets: [
                    new TextureAsset("medToHighJpegSheets", "sheets/MedToHigh_Sheets/MedToHigh_Sheets0.json")
                ],
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH]
            },
            {
                name: "symbols",
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("fsIntro", "spine/FS_Intro.json"),
                    new SpineAsset("xWords", "spine/X_Words.json"),
                    new SpineAsset("xSymTransform", "spine/X_Sym_Transform.json"),
                    new SpineAsset("bigWinInSpine", "spine/Big_Win.json"),
                    new SpineAsset("fsTextSpine", "spine/Collector_FS_FX.json"),
                    new SpineAsset("fsIndicatorSpine", "spine/Collector_Indicator_FX.json"),
                    new SpineAsset("sfsTextSpine", "spine/Collector_SFS_FX.json"),
                    new SpineAsset("sfsIndicatorSpine", "spine/Collector_Indicator_SFS_FX.json"),
                    new SpineAsset("xKnob", "spine/X_Knob.json"),
                    new SpineAsset("xKnobHand", "spine/X_Knob_Multiplier.json"),
                    new SpineAsset("xBPM", "spine/X_Bpm.json"),
                    new SpineAsset("fsBadOutro", "spine/No_Win.json"),
                    new SpineAsset("extraFS", "spine/Plus_2_FS.json"),
                    new SpineAsset("maxWin", "spine/Max_Win.json"),
                    new SpineAsset("luckyDraw", "spine/Lucky_Draw_FS.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}
